import { account } from '../api/api-endpoints'
import Vue from 'vue'
import api from '../api/api'
import storeHelper from '../utils/storeHelper'
import { notReactiveState } from './state'

export default {
  showPreloader ({commit}) {
    commit('preloader', true)
  },
  hidePreloader ({commit}) {
    commit('preloader', false)
  },
  downloadFile: function (context, options = {}) {
    let {endpoint, params = {}, reqMethod = 'get', data = {}} = options;
    if (!params.hasOwnProperty('responseType')) {
      params.responseType = 'blob'
    }
    if (!params.hasOwnProperty('disableGlobalError')) {
      params.disableGlobalError = true
    }
    if (reqMethod === 'post') {
      return api.post(context.getters.authToken, endpoint, data, params, context)
    }
    // saveFile({blob: r.request.response, fileName})
    return api.get(context.getters.authToken, endpoint, params, context)
  },
  updateUserData: function (context, options = {}) {

    let {cache = 0, ignoreCache = false} = options;
    if (context.getters.isGuest === true) {
      return Promise.resolve(1)
    }
    // return Promise.resolve(1)
    const userEndpoint = account.user();
    return context.dispatch('updateUrlEndpoint', {
      endpoint: userEndpoint,
      cache,
      ignoreCache
    }).then(response => {
      let data = {};
      try {
        data = context.getters.readUrlEndpoint(userEndpoint);
        // console.log(response)
        if (response.headers['user-updated']) {
          data.userUpdated = +response.headers['user-updated']
        } else {
          data.userUpdated = -1
        }
      } catch (e) {
        data = {role: 'admin'}
      }
      let userData = context.getters.userData;
      context.commit('userSetAuthData', Object.assign(userData, data));
      return response
    })
  },
  disableForm (context, {name = null, disable = false}) {
    let data = {
      disabledForms: {
        [name]: disable
      }
    };

    context.commit('mutateFormState', data)
  },
  deleteModels (context, payload) {
    let {ids, offline} = payload;

    if (offline) {
      ids.forEach(id => {
        payload.data = {
          id: id
        };
        context.commit('mutateModelDelete', payload)
      });
      return Promise.resolve(1)
    }
  },
  deleteModel (context, payload) {
    let {url, offline} = payload;

    if (offline) {
      context.commit('mutateModelDelete', payload);
      return Promise.resolve(1)
    }

    return api.deleteModel(context.getters.authToken, url, {}, context).then(
      (response) => {
        context.commit('mutateModelDelete', payload);
        return response
      }).catch(e => {
      return Promise.reject(e.response)
    })
  },
  updateUrlEndpoint (context, payload) {
    let {endpoint, url, params, notReactive = false, ignoreCache = false, fromCache = false, offline, cache = 0, noPreload = false} = payload;

    if (offline) {
      if (context.state.endpoints[endpoint]) {
        return Promise.resolve({data: context.state.endpoints[endpoint]})
      }
      return Promise.resolve({data: []})
    }

    if (fromCache === false) {
      if (context.getters.isCacheExpire({endpoint})) {
        fromCache = false
      } else {
        fromCache = true
      }
    }
    if (ignoreCache === true) {
      fromCache = false
    }

    if (fromCache && notReactive === false && context.state.endpoints[endpoint]) {
      return Promise.resolve({data: context.state.endpoints[endpoint]})
    } else if (fromCache && notReactive === true && notReactiveState.endpoints[endpoint]) {
      return Promise.resolve({data: notReactiveState.endpoints[endpoint]})
    }
    if (!noPreload) {
      context.commit('preloaderStart');
    }
    return api.get(context.getters.authToken, url || endpoint, params, context)
      .then((data) => {
        if (data) {
          context.commit('mutateCache', {endpoint, cache});
          context.commit('mutateEndpoint', {endpoint, notReactive, response: data})
        }
        return data
      }).catch(e => {
        if (!noPreload) {
          context.commit('preloaderEnd')
        }
        return Promise.reject(e.response)
      }).finally(() => {
        if (!noPreload) {
          context.commit('preloaderEnd')
        }
    })
  },
  createModel (context, payload) {
    let {url, data, params = {}, endpoint, action, offline, convertToFormData = false, formData = null} = payload;
    if (endpoint && action === undefined) {
      action = 'append'
    }

    if (!data) {
      data = {}
    }

    if (offline) {
      data._storeUUID = storeHelper.getNewStoreUUID();
      context.commit('mutateEndpoint', {endpoint, response: {data}, action});
      return Promise.resolve({data})
    }

    if (convertToFormData === true) {
      formData = storeHelper.convertObjectToFormData(data)
    }

    return api.saveModel(context.getters.authToken, url, formData || data, params, context).then(
      (response) => {
        if (endpoint) {
          payload.data = Object.assign(data, response.data);
          context.commit('mutateModel', payload)
        }
        return response
      }).catch(e => {
      return Promise.reject(e.response || e)
    })
  },
  updateModel (context, payload) {
    let {url, data, endpoint, offline, convertToFormData = false, params, formData = null} = payload;

    if (offline) {
      payload.data = Object.assign(data, {});
      context.commit('mutateModel', payload);
      console.log(payload);
      return Promise.resolve({data})
    }

    if (convertToFormData === true) {
      formData = storeHelper.convertObjectToFormData(data)
    }

    return api.updateModel(context.getters.authToken, url, formData || data, params, context).then(
      (response) => {
        if (endpoint) {
          payload.data = Object.assign(data, response.data);
          context.commit('mutateModel', payload)
        }
        return response
      }).catch(e => {
      return Promise.reject(e.response)
    })
  },
  userLogin: async (context, {username, password}) => {
    try {
      let loginResponse = await api.login(username, password, context).then(
        (response) => {
          context.commit('mutateEndpoint', {endpoint: 'currentUser', response: response, action: 'replace'});
          let userData = context.getters.readUrlEndpoint('currentUser');
          context.commit('userSetAuthData', userData);
          return response
        }
      ).catch(e => Promise.reject(e));
      await context.dispatch('updateUserData');
      return loginResponse
    } catch (er) {
      return Promise.reject(er)
    }
  },
  userLogout: ({commit}) => {
    if (Vue.prototype.$bugsnagClient) {
      Vue.prototype.$bugsnagClient.user = null
    }
    commit('userDelAuthData');
    return new Promise((resolve) => {
      resolve(1)
    })
    // api.logout()
  },
  uploadFile: (context, payload) => {
    let {url, data} = payload;

    let formData = storeHelper.convertObjectToFormData(data);

    return api.post(context.getters.authToken, url, formData, {}, context).then(
      (response) => {
        return response.data
      }
    ).catch(e => {
      return Promise.reject(e.response)
    })
  },
  postEndpoint: (context, payload) => {
    let {url, data} = payload;
    
    return api.post(context.getters.authToken, url, data, {}, context).then(
      (response) => {
        if (response.data) {
          context.commit('mutateCache', {endpoint: url, cache: 0});
          context.commit('mutateEndpoint', {endpoint: url, notReactive: false, response })
        }
        return response?.data || null
      }
    ).catch(e => {
      return Promise.reject(e.response)
    })
  }
}
